module.exports = __webpack_public_path__ + "static/img/third1.ac75329.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/third1.png
// module id = qpIB
// module chunks = 25